module.exports = __webpack_public_path__ + "static/team_8-50cdf2a3087a90c812c1fd9f8d13be9b.jpg";